import React from 'react';
import { useNavigate } from 'react-router';
import Button from '~/shared/components/andtComponents/Button.js';
import { Routes } from '~/shared/constants/routes.js';
import { ReactComponent as Clouds } from 'app/containers/AdminWelcome/assets/clouds.svg';
import { useBrand } from '~/app/contexts/Brand/BrandContext.js';

import styles from 'app/containers/AdminWelcome/AdminLanding.module.scss';
import ConfettiAnimation from 'app/containers/AdminWelcome/ConfettiAnimation/index.jsx';

const AdminWelcome = () => {
  const brand = useBrand();
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Welcome to the New User Management</h1>
          <div className={styles.subContent}>
            <p>
              As an administrator, you can impersonate any user working with new User Management and manage feature
              flags for the entire system.
            </p>

            <div className={styles.actionsList}>
              <Button size="large" onClick={() => navigate(Routes.FEATURE_FLAGS)} text="Change Feature Flags" />
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <div className={styles.userIcons}>
            <div className={styles.userIcon} style={{ width: '45px', height: '45px' }}>
              <span role="img" aria-label="user">
                👤
              </span>
            </div>
            <div className={styles.userIcon} style={{ width: '65px', height: '65px' }}>
              <span role="img" aria-label="users">
                👥
              </span>
            </div>
            <div className={styles.userIcon} style={{ width: '55px', height: '55px' }}>
              <span role="img" aria-label="permission">
                🔑
              </span>
            </div>
            <div className={styles.userIcon} style={{ width: '50px', height: '50px' }}>
              <span role="img" aria-label="settings">
                ⚙️
              </span>
            </div>
            <div className={styles.userIcon} style={{ width: '60px', height: '60px' }}>
              <span role="img" aria-label="security">
                🔒
              </span>
            </div>
          </div>
          <div className={styles.sunLight} />
          <brand.sun className={styles.sun} />
          <Clouds className={styles.clouds} />
        </div>
      </div>
      <ConfettiAnimation />
    </>
  );
};


export default AdminWelcome;
